import Input from '@mui/material/Input';
import { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useCallback, useState } from 'react';
import { useField, useForm } from 'react-final-form';

import InfoPrompt from '../../../InfoPrompt/InfoPrompt';

import {
  TXTWCL_Having_your_limits_in_USD_can__ELL,
  TXTWCL_Our_XXBrandXX_offering_is_glob_ELL,
  TXTWCL_Why_can_I_set_my_limits_in_USD_ELL
} from './Switch.messages.json';
import {
  active,
  checked,
  container,
  currencies,
  defaultCurrency,
  input,
  label,
  labelWrapper,
  localCurrency,
  toggle,
  wrapper
} from './Switch.scss';

interface Props {
  currency: Currency;
  fieldName: string;
}

const defaultSystemCurrency = Currency.USDollar;

const Switch: React.FC<Props> = ({ currency, fieldName }) => {
  const form = useForm();
  const [isChecked, setIsChecked] = useState(false);
  const {
    input: { value: selectedCurrency }
  } = useField(`${fieldName}.currency`, { subscription: { value: true }, initialValue: currency });

  const handleCurrencyChange = useCallback(
    ({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
      setIsChecked(checked);
      form.change(`${fieldName}.currency`, checked ? defaultSystemCurrency : currency);
    },
    [currency, fieldName, form]
  );

  return (
    <div className={container}>
      <Input
        id="switch"
        type="checkbox"
        className={classNames(input, { [checked]: isChecked })}
        onChange={handleCurrencyChange}
      />
      <div className={wrapper}>
        <div className={labelWrapper}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="switch" className={label}>
            <div className={toggle} />
            <div className={currencies}>
              <span
                className={classNames(localCurrency, { [active]: selectedCurrency === currency })}
              >
                {currency}
              </span>
              <span
                className={classNames(defaultCurrency, {
                  [active]: selectedCurrency === defaultSystemCurrency
                })}
              >
                {defaultSystemCurrency}
              </span>
            </div>
          </label>
        </div>
        <InfoPrompt
          variant="switch"
          title={{ translation: TXTWCL_Why_can_I_set_my_limits_in_USD_ELL }}
        >
          <p>
            <Translation {...TXTWCL_Our_XXBrandXX_offering_is_glob_ELL} />{' '}
            <Translation {...TXTWCL_Having_your_limits_in_USD_can__ELL} />
          </p>
        </InfoPrompt>
      </div>
    </div>
  );
};

export default Switch;
